import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetReportParametersRequest,
  GetReportParametersResponse,
  GetReportsRequest,
  GetReportsResponse,
  SaveFavoriteRequest,
  SaveFavoriteResponse,
  GetFavoritesRequest,
  GetFavoritesResponse,
  GetFavoriteParametersRequest,
  GetFavoriteParametersResponse,
  DeleteFavoriteRequest,
  DeleteFavoriteResponse,
} from "../../models/Report.model";
import {
  GetReportDataRequest,
  GetReportDataResponse,
} from "../../models/ReportData.model";

const API_BASE_URL = environment.apiUrl;

export const GetReports = createAsyncThunk<
  GetReportsResponse,
  GetReportsRequest,
  { rejectValue: string }
>("report/GetReports", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Report/GetReports`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetReportsResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch base tables");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const GetReportParameters = createAsyncThunk<
  GetReportParametersResponse,
  GetReportParametersRequest,
  { rejectValue: string }
>("report/GetReportParameters", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Report/GetReportParameters`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: GetReportParametersResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(
        data.message || "Failed to fetch report parameters"
      );
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const GetReportData = createAsyncThunk<
  GetReportDataResponse,
  GetReportDataRequest,
  { rejectValue: string }
>("report/GetReportData", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Report/GetReportData`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: GetReportDataResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(data.message || "Failed to fetch report data");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
export const SaveFavorite = createAsyncThunk<
  SaveFavoriteResponse,
  SaveFavoriteRequest,
  { rejectValue: string }
>("report/SaveFavorite", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Report/SaveFavorite`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: SaveFavoriteResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(data.message || "Failed to save favorite");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const GetFavorites = createAsyncThunk<
  GetFavoritesResponse,
  GetFavoritesRequest,
  { rejectValue: string }
>("report/GetFavorites", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Report/GetFavorites`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: GetFavoritesResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(data.message || "Failed to get favorites");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const GetFavoriteParameters = createAsyncThunk<
  GetFavoriteParametersResponse,
  GetFavoriteParametersRequest,
  { rejectValue: string }
>("report/GetFavoriteParameters", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Report/GetFavoriteParameters`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: GetFavoriteParametersResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(data.message || "Failed to get favorite parameters");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
export const DeleteFavorite = createAsyncThunk<
  DeleteFavoriteResponse,
  DeleteFavoriteRequest,
  { rejectValue: string }
>("report/DeleteFavorite", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}Report/DeleteFavorite`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: DeleteFavoriteResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(
        data.message || "Failed to delete favorite"
      );
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
